import { DigitalIntervalOptionsType } from './Filters';
import { GraphErrataEnum } from '@shared/dictionaries';

export enum ChannelGroupSideType {
  Left,
  Right,
}

export interface ChannelGroupModel {
  ids: number[];
  side: ChannelGroupSideType;
}

export interface ChannelTypeUnitsAndPercentageModel {
  channelTypeUnitOptions: ChannelTypeUnits[];
  canShowPercentage: boolean;
}

export enum IntervalOptionMode {
  None = 'None',
  FlowRate = 'FlowRate',
  CumulativeMode = 'CumulativeMode',
}

export interface ChannelUnitsAndIntervalsModel {
  units: ChannelUnitsModel[];
  intervals?: ChannelIntervalsModel[];
  intervalMode: IntervalOptionMode;
}

export interface ChannelTypeUnits extends ChannelUnitsAndIntervalsModel {
  type: string;
}
export interface ChannelUnitsModel {
  name: string;
  isDefault: boolean;
}

export interface ChannelIntervalsModel {
  interval: DigitalIntervalOptionsType;
  isDefault: boolean;
}

export interface GraphModel {
  errata?: ErrataInfoModel[];
  boundaries?: AlarmBoundaryModel[];
  data: GraphDataModel[];
}

export interface ErrataInfoModel {
  siteId: number;
  deviceId: number;
  problem: GraphErrataEnum;
  canRequestDeviceConfig: boolean;
  deviceConfigRequestedDate?: string; // as Date
}

export interface AlarmBoundaryModel {
  upperVal?: number;
  lowerVal?: number;
  scale: string;
  channelIds: number[];
  lowerPc?: number;
  upperPc?: number;
}

export interface GraphDataModel {
  siteId: number;
  name: string;
  address: string;
  interval: string;
  isPrvController?: boolean;
  dataStart?: string;
  dataEnd?: string;
  device: DeviceModel;
  channelData: GraphChannelModel[];
}

export interface DeviceModel {
  sms: string;
  model: string;
  version: string;
  sampleRate: string;
  signalLevel: number;
  ecl?: number;
  rsrp?: number;
  rsrq?: number;
  battery: string;
  lastCallIn: string; // as date
  lastCallInType: string;
  numberOfCallIns: number;
  lastRestart?: string; // as date
}

export enum ChannelSeries {
  Line = 'Line',
  Bar = 'Bar',
}

export interface GraphChannelModel {
  channelId: number;
  channelNumber?: number;
  name: string;
  type: string;
  unit: string;
  isSecondary: boolean;
  min: number;
  max: number;
  avg: number;
  total: number;
  meter?: number;
  meterUnits?: string;
  meterTime?: string; // as date
  series: ChannelSeries;
  data?: ChannelDataModel[];
}

export interface ChannelDataModel {
  date: string; // as date
  value: number;
  meterValue?: number;
  transientID?: number;
  transientStartTime?: string; // as date
  transientRateHz?: number;
}
